import React, {ComponentProps} from "react"
import {Meta, Story} from "@storybook/react"
import ModalAbout from "@components/molecules/ModalAbout"
import sharedLocales from "@locales/views/shared/ja.yml"

type PropTypes = ComponentProps<typeof ModalAbout>

export default {
  title: "Molecules/ModalAbout",
  component: ModalAbout,
} as Meta

const Template: Story<PropTypes> = (args) => <ModalAbout {...args} />

export const Default = Template.bind({})
Default.args = {
  data: {
    step_files: [...Array(10)].map(
      (_, index) => `https://placeimg.com/640/480/${index}`
    ),
    t: sharedLocales.ja.shared.popup_about,
  },
}
